export const siteSettings = {
  name: "Pro Crypto Market Trades",
  link: "https://procryptomarketstrading.live",
  email: "support@procryptomarketstrading.live",
  appLink: "https://app.procryptomarketstrading.live",
};
